import React from 'react'
import styles from "./Home.module.css";

const Home = () => {
    return (
        <div id="view-home">
           <img className={styles.image} src='https://i.imgur.com/nJ7uGZE.jpg' alt='frase de viajar'></img>
        </div>
        
    )
}

export default Home